import FontFade from '../FontFade';
import Swiper from '../Swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFAddCircle from '@/components/UI/svg/CSR/Icons/EFAddCircle';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/csr/pc/');

export default function D(): JSX.Element {
    const { useLang, useEffect, useState, Link } = useGlobal();
    const { t } = useLang('csr');
    const itemWidth = 380;
    const gap = 36;

    const itemList = [
        {
            name: t('secD_list1_pName'),
            img: 'd-1',
            desc: t('secD_list1_pDesc'),
            link: t('secD_list_link'),
            moreInfo: t('secD_list1_pTimeDesc'),
            showMore: false,
            pLink: '/delta-pro-portable-power-station',
            showButton: true,
        },
        {
            name: t('secD_list2_pName'),
            img: 'd-2',
            desc: t('secD_list2_pDesc'),
            link: t('secD_list_link'),
            moreInfo: t('secD_list2_pTimeDesc'),
            showMore: false,
            pLink: '/delta-max-portable-power-station',
            showButton: true,
        },
        {
            name: t('secD_list3_pName'),
            img: 'd-3',
            desc: t('secD_list3_pDesc'),
            link: t('secD_list_link'),
            moreInfo: t('secD_list3_pTimeDesc'),
            showMore: false,
            pLink: '/delta-2-portable-power-station',
            showButton: true,
        },
        {
            name: t('secD_list4_pName'),
            img: 'd-4',
            desc: t('secD_list4_pDesc'),
            link: t('secD_list_link'),
            moreInfo: t('secD_list3_pTimeDesc'),
            showMore: false,
            pLink: '/400w-solar-panel',
            showButton: false,
        },
        {
            name: t('secD_list5_pName'),
            img: 'd-5',
            desc: t('secD_list5_pDesc'),
            link: t('secD_list_link'),
            moreInfo: t('secD_list3_pTimeDesc'),
            showMore: false,
            pLink: '/220w-solar-panel',
            showButton: false,
        },
    ];
    const [curList, setCurList] = useState(itemList);

    const handleClick = (item: any, index: number) => {
        const newList = [...curList];
        newList[index].showMore = !item.showMore;
        setCurList(newList);
    };

    const items = curList.map((item: any, index: number) => {
        const style = {
            width: `${itemWidth}px`,
            marginRight: `${gap}px`,
        };

        const active = item.showMore ? 'active' : '';

        return (
            <div key={index} style={style} className={`listItem listItem_${index}`}>
                <div className={`innerListBox innerListBox_${index}`}>
                    <div className={`dListBaseInfo ${active}`}>
                        <div className="dListimg">
                            <EFPic name={[`${item.img}.webp`, `${item.img}.png`]} />
                        </div>
                        <div className="dItemTitle">{item.name}</div>
                        <div className="dItemDesc">{item.desc}</div>
                        <div className="secD_list_link">
                            <Link className="secD_link_text" href={item?.pLink} target="_blank">
                                {item.link}
                            </Link>
                        </div>
                    </div>
                    <div className={`dListMoreInfo ${active}`}>
                        <div>{t('secD_list_pTime')}</div>
                        <div>{item.moreInfo}</div>
                    </div>
                    {item.showButton && (
                        <div className={`dListIconBox ${active}`} onClick={() => handleClick(item, index)}>
                            <EFAddCircle />
                        </div>
                    )}
                </div>
            </div>
        );
    });

    useEffect(() => {
        const ScrollMagic = (window as any).ScrollMagic;
        const scene = new ScrollMagic.Scene({
            triggerElement: '.csrSwiperD',
            triggerHook: 1,
            offset: 300,
        }).setClassToggle('.csrSwiperD', 'show');

        new ScrollMagic.Controller().addScene(scene);
    }, []);

    return (
        <div className={`csr_pc_D ${css.csr_pc_D}`}>
            <div className="container secD_title">
                <FontFade className="sec-d-title-text" offset={50}>
                    {t('secD_title')}
                </FontFade>
            </div>
            <Swiper itemWidth={itemWidth} gap={gap} className="csrSwiperD" isRightAlign={true}>
                {items}
            </Swiper>
            <div className="container secD_note">{t('secD_note')}</div>
        </div>
    );
}
